import Invoice2Container from "../../../../components/applications/eCommerce/invoices/invoice2";

const Invoice2 = () => {
  return <Invoice2Container />;
};

export default Invoice2;
